export const departmentListTableConfig = [
  {
    field: 'slNo',
    header: 'Sl. No',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'departmentList',
    header: 'Department Name',
    className: 'department-list-data-column',
    headerClassName: 'department-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'status',
    header: 'Status',
    className: 'department-list-data-column',
    headerClassName: 'department-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'department-list-data-column department-list-action-column',
    headerClassName: 'department-list-data-column department-list-action-column',
    width: 180,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
  },
];
